import type { ReactNode } from "react";
import type { SortDir, SortState } from "./useTableSort";
import s from "./SortableTh.module.css";

const GLYPH: Record<SortDir, string> = { asc: "▲", desc: "▼" };

/** Sortable column header for the shared .table grammar (ADR 151). Renders a
 *  real button (keyboard-operable, visible focus ring) and reports the state
 *  on the th via aria-sort — state is never conveyed by the glyph alone. */
export function SortableTh<K extends string>({ label, sortKey, sort, onToggle }: {
  label: ReactNode;
  sortKey: K;
  sort: SortState<K> | null;
  onToggle: (key: K) => void;
}) {
  const dir = sort?.key === sortKey ? sort.dir : null;
  return (
    <th aria-sort={dir === "asc" ? "ascending" : dir === "desc" ? "descending" : undefined}>
      <button type="button" className={s.btn} onClick={() => onToggle(sortKey)}>
        {label}
        <span className={dir ? `${s.icon} ${s.iconActive}` : s.icon} aria-hidden="true">
          {dir ? GLYPH[dir] : "↕"}
        </span>
      </button>
    </th>
  );
}
